module.exports = __webpack_public_path__ + "static/media/alpha1.c950423d.png";